(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
      if (this.dataset.forceCollapsed === 'true') {
       this.disclosure.open = false;
       this.toggle.removeAttribute('tabindex');
       return;
      }
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        // Force-collapsed håndteres af vores egen click-listener (se længere nede)
        if (this.dataset.forceCollapsed === 'true') return;

        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }

    }

// FORCE-COLLAPSED: stop alt andet (pointerdown + click) og toggl kun på knappen
const isForcedSummary = (el) =>
  el && el.closest && el.closest('nav-menu[data-force-collapsed="true"] summary');

document.addEventListener('pointerdown', (e) => {
  const summary = isForcedSummary(e.target);
  if (!summary) return;

  // Stop alt andet kode der lytter på pointerdown/mousedown
  e.preventDefault();
  e.stopImmediatePropagation();
}, true);

document.addEventListener('click', (e) => {
  const summary = isForcedSummary(e.target);
  if (!summary) return;

  // Stop native <summary> toggle + andre click handlers
  e.preventDefault();
  e.stopImmediatePropagation();

  // Kun knappen må toggle
  const btn = e.target.closest('.js-force-collapsed-toggle');
  if (!btn) return;

  const details = summary.closest('details');
  if (!details) return;

  details.open = !details.open;
  btn.setAttribute('aria-expanded', details.open ? 'true' : 'false');
}, true);


  });

  } catch(e) { console.error(e); }
})();
})();
